import {useLoaderData} from "@remix-run/react";

const GTAG_GID = "GTM-KFJJNSH";

export default function ExternalScripts() {
  const data = useLoaderData();
  const adsScriptSrc = data?.script?.ad_script;
  const adsEnable = data?.script?.ad_enable;
  return (
    <>
      {adsEnable && <script type="text/javascript" async src={adsScriptSrc} />}
      <script async src={`https://www.googletagmanager.com/gtm.js?id=${GTAG_GID}`} />
      <script
        async
        id="gtm-init"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${GTAG_GID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
    </>
  );
}
